<template>
    <div>
        <InfosForm @go-back="$emit('goBack')" @go-to-next="$emit('continueWithUser', user)"  :user="user" v-if="userLoaded && user != undefined" />
        <LoginForm @user-connected="user = $event" @go-to-no-user="formShowed = 'no-user'" @go-back="$emit('goBack')" @go-to-signup="formShowed = 'signup'" v-if="userLoaded && user == undefined && formShowed == 'login'" />
        <SignupForm @go-to-login="formShowed = 'login'" @user-connected="user = $event"   v-if="userLoaded && user == undefined && formShowed == 'signup'" />
        <NoUserForm @go-with-no-user="$emit('continueWithUser', $event)" @go-to-login="formShowed = 'login'"  v-if="userLoaded && user == undefined && formShowed == 'no-user'" />
        
        <div v-if="isLoadingUser" class="mt-10 flex justify-center w-full">
            <div aria-label="Loading..." role="status"><svg class="animate-spin w-10 h-10 fill-slate-800" viewBox="3 3 18 18">
                <path class="opacity-20"
                    d="M12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5ZM3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12Z">
                </path>
                <path
                    d="M16.9497 7.05015C14.2161 4.31648 9.78392 4.31648 7.05025 7.05015C6.65973 7.44067 6.02656 7.44067 5.63604 7.05015C5.24551 6.65962 5.24551 6.02646 5.63604 5.63593C9.15076 2.12121 14.8492 2.12121 18.364 5.63593C18.7545 6.02646 18.7545 6.65962 18.364 7.05015C17.9734 7.44067 17.3403 7.44067 16.9497 7.05015Z">
                </path>
            </svg></div>
        </div>
    </div>
</template>

<script>

import axios from 'axios';

import LoginForm from './LoginForm.vue'
import InfosForm from './InfosForm.vue'
import SignupForm from './SignupForm.vue'
import NoUserForm from './NoUserForm.vue'

export default {

    components: { LoginForm, InfosForm, SignupForm, NoUserForm },
    props: {
        currentUser: {}
    },
    data() {
        return {
            userLoaded: !!this.currentUser,
            isLoadingUser: false,
            user: this.currentUser,
            formShowed: 'login'
        }
    },
    mounted() {
        if(!this.currentUser)
            this.loadUser();
    },
    methods: {
        async loadUser() {
            console.log("User will be loaded");
            try {
                this.isLoadingUser = true;
                const user = (await axios.get('/auth/me')).data;
                this.user = user;
                this.userLoaded = true;
            } catch (e) {
                console.log(e.response)
                if (e.response && e.response.status == 401) {
                    this.userLoaded = true;
                }
            } finally {
                this.isLoadingUser = false;
            }
        }
    }
}
</script>